// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useSelector } from "react-redux";
// const AdminReviews = () => {
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const { token } = useSelector((state) => state.auth);
//   const fetchReviews = async () => {
//     try {
        
//     //   const token = localStorage.getItem("token"); // Admin token
//       const response = await axios.get("http://localhost:4000/api/v1/course/ratings", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setReviews(response.data.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Failed to fetch reviews", error);
//       setLoading(false);
//     }
//   };

//   const deleteReview = async (reviewId) => {
//     try {
//     //   const token = localStorage.getItem("token");
//       await axios.delete(`http://localhost:4000/api/v1/course/ratings/${reviewId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setReviews((prev) => prev.filter((review) => review._id !== reviewId));
//     } catch (error) {
//       console.error("Failed to delete review", error);
//     }
//   };

//   useEffect(() => {
//     fetchReviews();
//   }, []);

//   if (loading) return <div>Loading...</div>;

//   return (
//     <div className="admin-reviews">
//       <h1>Manage Ratings and Reviews</h1>
//       {reviews.length === 0 ? (
//         <p>No reviews available</p>
//       ) : (
//         <table>
//           <thead>
//             <tr>
//               <th>User</th>
//               <th>Course</th>
//               <th>Rating</th>
//               <th>Review</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {reviews.map((review) => (
//               <tr key={review._id}>
//                 <td>{review.user?.firstName} {review.user?.lastName}</td>
//                 <td>{review.course?.courseName}</td>
//                 <td>{review.rating}</td>
//                 <td>{review.review}</td>
//                 <td>
//                   <button onClick={() => deleteReview(review._id)}>Delete</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default AdminReviews;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { FaStar, FaCommentDots } from "react-icons/fa";
import { toast } from 'react-hot-toast';
const AdminReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useSelector((state) => state.auth);
 const BASE_URL = process.env.REACT_APP_BASE_URL;
  const fetchReviews = async () => {
    try {
      const response = await axios.get(
       `${BASE_URL}/course/ratings`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setReviews(response.data.data);
      
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch reviews", error);
      setLoading(false);
      toast.error("Failed to fetch reviews!");
    }
  };

  const deleteReview = async (reviewId) => {
    try {
      await axios.delete(
        `${BASE_URL}/course/ratings/${reviewId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setReviews((prev) => prev.filter((review) => review._id !== reviewId));
      toast.success("Review deleted successfully!");
    } catch (error) {
      console.error("Failed to delete review", error);
      toast.error("Failed to delete review!");
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  if (loading)
    return (
        <div className="grid place-items-center">
        <div className="spinner"></div>
      </div>
    );

  return (
    <div className="p-4 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">
        Ratings and Reviews
      </h1>
      {reviews.length === 0 ? (
        <p className="text-center text-gray-500">
          No reviews available at the moment.
        </p>
      ) : (
        <div className="overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-700">
            <thead className="text-xs text-gray-500 uppercase bg-pure-greys-300">
              <tr>
                <th className="px-6 py-3">User</th>
                <th className="px-6 py-3">Course</th>
                <th className="px-6 py-3">Rating</th>
                <th className="px-6 py-3">Review</th>
                <th className="px-6 py-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {reviews.map((review) => (
                <tr
                  key={review._id}
                  className="bg-white border-b hover:bg-pure-greys-50"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    {review.user?.firstName} {review.user?.lastName}
                  </td>
                  <td className="px-6 py-4">{review.course?.courseName}</td>
                  <td className="px-6 py-4"> {review.rating}</td>
                    {/* Handle long reviews */}
                   <td className="px-4 py-4">
                    <div className="relative group">
                      <p className="truncate max-w-xs sm:max-w-md lg:max-w-lg">
                        {review.review}
                      </p>
                      <div className="absolute top-full mt-2 hidden group-hover:block bg-white shadow-lg border rounded-md p-2 text-gray-800 max-w-md z-10">
                        {review.review}
                      </div>
                    </div>
                  </td>
{/*                   <td className="px-6 py-4"><FaCommentDots className="mr-1 text-gray-600" />{review.review}</td> */}
                  <td className="px-6 py-4 text-center">
                    <button
                      onClick={() => deleteReview(review._id)}
                      className="text-white bg-pink-500 hover:bg-pink-600 font-medium rounded-md px-3 py-1 transition-all duration-200"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminReviews;
